// extracted by mini-css-extract-plugin
export default {"background":"modal_background__fWdsE","foreground":"modal_foreground__3DnWH"};